import { render, staticRenderFns } from "./member_account_record_list.vue?vue&type=template&id=bbc4edd6&scoped=true"
import script from "./member_account_record_list.vue?vue&type=script&lang=js"
export * from "./member_account_record_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4edd6",
  null
  
)

export default component.exports